export default __webpack_public_path__ + "static/media/3-3.68b7ed2c.png";